export enum TellentDevFlag {
  OneBilling = 'one_billing_released',
  UnifiedGroups = 'unified_groups',
  UnifiedDepartments = 'unified_departments',
  AppShell = 'app_shell',
  IntelligenceSettings = 'intelligence_settings',
  OneSettings = 'one_settings',
  OneDomain = 'one_domain',
}

export type TellentDevFlagsMap = Record<TellentDevFlag, boolean>;

export type DevFlagsFetchResponse = {
  data: TellentDevFlag[];
};
